"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M22.638 19.917a2.75 2.75 0 01-3.01 2.749 20.532 20.532 0 01-8.952-3.183 20.242 20.242 0 01-6.227-6.225 20.55 20.55 0 01-3.188-9.01A2.75 2.75 0 013.998 1.25h2.993a2.752 2.752 0 012.75 2.372c.12.904.341 1.792.66 2.644a2.751 2.751 0 01-.623 2.904l-.858.858a15.25 15.25 0 004.94 4.94l.86-.861a2.75 2.75 0 012.9-.62c.855.32 1.742.54 2.653.66a2.75 2.75 0 012.365 2.782v2.988zm-1.5-2.997a1.254 1.254 0 00-1.068-1.286 13.594 13.594 0 01-2.976-.742 1.249 1.249 0 00-1.316.278l-1.27 1.27a.75.75 0 01-.9.122 16.75 16.75 0 01-6.282-6.281.75.75 0 01.122-.901l1.267-1.267a1.25 1.25 0 00.28-1.32 13.573 13.573 0 01-.74-2.968A1.252 1.252 0 006.999 2.75h-3A1.25 1.25 0 002.755 4.1a19.047 19.047 0 002.957 8.348 18.758 18.758 0 005.775 5.773 19.028 19.028 0 008.29 2.952 1.25 1.25 0 001.362-1.253v-3z"
  }));
};

SvgPhone.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
SvgPhone.defaultProps = {
  color: "currentColor",
  size: "24"
};
var _default = SvgPhone;
exports["default"] = _default;
module.exports = exports.default;